module.exports = __webpack_public_path__ + "img/icon_gotop.4ae71a89.svg";